import { Modal, ModalBody, ModalContent, ModalOverlay } from "@chakra-ui/react";
import { useRef } from "react";
import { RequirementDialogHeader } from "../../../../common/components/RequirementDialogHeader";
import { ScoreScale } from "../bid-detail/ScoreScale";

interface Props {
  isOpen: boolean;
  onClose: () => void;
  criterionName: string;
  supplierName: string;
  points: number | null;
  onChange: (value: number | null) => void;
  isReadOnly?: boolean;
}

export const ScoreDialog = ({
  isOpen,
  onClose,
  criterionName,
  supplierName,
  points,
  onChange,
  isReadOnly = false,
}: Props) => {
  const scale = useRef<HTMLDivElement>(null);

  return (
    <Modal isOpen={isOpen} onClose={onClose} size="xl" isCentered initialFocusRef={scale}>
      <ModalOverlay />
      <ModalContent>
        <RequirementDialogHeader title={criterionName} subtitle={supplierName} />
        <ModalBody pb="6">
          <ScoreScale
            ref={scale}
            value={points}
            onChange={onChange}
            isReadOnly={isReadOnly}
            onDone={onClose}
          />
        </ModalBody>
      </ModalContent>
    </Modal>
  );
};
